<div class="d-flex align-items-center">
  <div class="drop">
    <div class="drop-header">
      <a [href]=" phones()[0].contact" class="drop-header__link"> {{ phones()[0].label }} </a>
      <span class="drop-button" (click)="dropdownClicked()">
       <img [class.arrow-down]="isDropdown()"
            alt="arrow-up"
            class="arrow-up"
            loading="lazy"
            src="assets/images/icons/arrow-up.svg" />
    </span>
    </div>
    <span class="drop-label">{{ 'NEED_HELP' | translate }}</span>
    @if(isDropdown()) {
      <div class="drop-content">
        <div class="phone drop-item">
          <img alt="icon" height="24" src="assets/images/icons/icon-phone-yellow.svg" width="24" />
          <a [href]="phones()[1].contact" class="phone-link"> {{ phones()[1].label }} </a>
        </div>
        <div class="hours drop-item">
          <h5>{{ 'SUPPORT_WORKS' | translate }}</h5>
          <div class="hours-down">
            <img alt="icon" height="20" src="assets/images/icons/clock.svg" width="20" />
            <span>Пн-Нд: 9:00 - 21:00</span>
          </div>
        </div>
        @if (isLogoutVisible() || isLoanExist()) {
          <div class="drop-item">
            <button class="logout" (click)="logout()">
              <span>{{ 'BUTTON.LOGOUT' | translate }}</span>
              <img src="assets/images/icons/logout.svg" alt="logout" width="14" height="15" />
            </button>
          </div>
        }
      </div>
    }
  </div>
  <div>
  </div>
</div>
